import React from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import climbing from '../../Assets/climbing.png';
import beachinfo from '../../Assets/beachinfo.png';
import wlsos from '../../Assets/wlsos.png';
import AOS from "aos";
import '../../Styles/projects.css'

const Projects = () => {
  return (
    <div className="page-container">
      <div className="page-title">
        <h1 data-aos="fade-up">PROJECTS</h1>
      </div>
      <div className="page-div">
        <Grid container spacing={2} justifyContent="start">
          <Grid item xs={12} sm={6} md={4} data-aos="flip-left">
            <Card>
              <CardMedia
                sx={{ height: 140 }}
                image={wlsos}
                title="waterlevel sos"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  하천 범람 SOS
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  프로젝트 기간: 2023.08.21 ~ 2023.09.22 <br />
                  돌발 홍수가 잦아지면서 하천 수위가 급격하게 상승하여 많은 피해를 일으켰음. 기상 예보와 현재 강우량을 반영한 하천 범람 여부 예측 필요. 최근 강수 경향과 지형과 하천 수계에 따라 수분 흡수율이 다름. 일반화된 계산식을 도출할 수 없으므로 하천별 학습 모델 개발이 필요함.
                  하천을 선정하고 상류 AWS 정보와 수위를 학습시켜 모델 개발함
                </Typography>
              </CardContent>
              <CardActions>
                {/* <a href='https://docs.google.com/presentation/d/1B6WCFmUJxUtVQKcRACpAEnA3fTNDfeGb/edit?usp=share_link&ouid=115765982386395845923&rtpof=true&sd=true'><Button size="small">ppt</Button></a> */}
                <a href='https://drive.google.com/file/d/1KQCx8yGqgl4epvGeDX9SFef9I0QpAn_W/view?usp=share_link'><Button size="small">pdf</Button></a>
                <a href='https://www.notion.so/f2dc1ffe37f64470b9ee28c620044968'><Button size="small">notion</Button></a>
                <a href='https://github.com/hong-sehyun/WaterLevel_SOS'><Button size="small">github</Button></a>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4} data-aos="flip-left">
            <Card>
              <CardMedia
                sx={{ height: 140 }}
                image={beachinfo}
                title="beach info"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  Beach Info
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  프로젝트 기간: 2023.07.24 ~ 2023.08.09 <br />
                  해수욕장의 위치, 개폐장 일정 등을 피서객에게 제공함으로써 방문객들이 해수욕장을 더 잘 이해하고 방문할 수 있게 함  <br />
                  리뷰, 사진 업로드 등의 기능을 통해 다른 사용자들과 경험을 공유할 수 있는 플랫폼 제공
                </Typography>
              </CardContent>
              <CardActions>
                {/* <a href='https://www.notion.so/f2dc1ffe37f64470b9ee28c620044968'><Button size="small">notion</Button></a> */}
                <a href='https://github.com/hong-sehyun/BeachInfo'><Button size="small">github</Button></a>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4} data-aos="flip-left">
            <Card>
              <CardMedia
                sx={{ height: 140 }}
                image={climbing}
                title="climbing"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  CLIMBING
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  프로젝트 기간: 2023.08.24 ~ 2023.08.26 <br />
                  클리이밍 정보 웹사이트 Figma 디자인
                </Typography>
              </CardContent>
              <CardActions>
                {/* <a href='https://www.notion.so/f2dc1ffe37f64470b9ee28c620044968'><Button size="small">notion</Button></a> */}
                <a href='https://www.figma.com/proto/2nIqnYLcfjjmRw27VEVV4T/%EB%B0%98%EC%9D%91%ED%98%95-%EC%9B%B9%EC%82%AC%EC%9D%B4%ED%8A%B8(%ED%99%8D%EC%84%B8%ED%98%84)?type=design&node-id=1-2&t=UzHlk6UYa5RjTmBK-1&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=1%3A2&mode=design'><Button size="small">figma</Button></a>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div >
  )
}

export default Projects